import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const MyLibrarySaveConfirm = props => {

	const message = props.message || localize('my_library_save_confirm_message')

	return (
		<Confirm
			btTwo={localize('global_tooltip_gotIt')}
			alertMessage={message}
			actionButtonType={0}
			actionTwo={() => {
				props.actions.closeSaveConfirm()
			}}
			closeAction={() => {
				props.actions.closeSaveConfirm()
			}}
		/>
	)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeSaveConfirm: myLibraryActions.closeSaveConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibrarySaveConfirm)
